
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from 'vee-validate';
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import FormSelect from "@/components/form/FormSelectNew.vue";
import StandardizedPhoneInput from "@/components/form/StandardizedPhoneInput.vue";
import _ from 'lodash';

@Component({
  components: {
    ValidationProvider,
    FormGroup,
    FormInputGroup,
    FormTextarea,
    FormSelect,
    StandardizedPhoneInput
  }
})
export default class EmergencyContact extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;

  localFormData: Record<string, any> = {};

  @Watch('formData', { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    this.localFormData = _.cloneDeep(newVal);
  }

  updateField(field: string, value: any) {
    this.localFormData[field] = value;
    this.$emit('update:formData', this.localFormData);
  }

  handlePhoneValidation(validation: { isValid: boolean; message?: string; value: string }) {
    // Additional phone validation handling if needed
    if (!validation.isValid && validation.message) {
      console.debug('Emergency contact phone validation error:', validation.message);
    }
  }
}
